import { selectorForSlice, setState } from 'lp-redux-utils';
import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as actions from './actions';
import { reducer as applicantsReducer, reducerKey as applicantsReducerKey, } from './applicants';
import { slice as edsReducer } from './apply/eds';
import { reducer as creditApplicationReducer, reducerKey as creditApplicationReducerKey, } from './credit_application';
import findMyAccountReducer from './find-my-account/slice';
import { reducer as flexFinalizeReducer, reducerKey as flexFinalizeReducerKey, } from './flex-finalize';
import { slice as receiptsReducer } from './receipt';
const reducerKey = 'creditPortal';
const slice = 'root.creditPortal.root';
const initialState = {
    submittedOtaToken: null,
};
const creditPortalReducer = handleActions({
    [actions.setSubmittedOtaToken.toString()]: setState('submittedOtaToken'),
}, initialState);
const reducer = combineReducers({
    ['root']: creditPortalReducer,
    [applicantsReducerKey]: applicantsReducer,
    [creditApplicationReducerKey]: creditApplicationReducer,
    [flexFinalizeReducerKey]: flexFinalizeReducer,
    ['receipt']: receiptsReducer,
    findMyAccount: findMyAccountReducer,
    eds: edsReducer,
});
const select = selectorForSlice(slice);
const selectors = {
    submittedOtaToken: select('submittedOtaToken'),
};
export { reducer, selectors, reducerKey };
